<template lang="pug">
  .page-account
    h1 Sign Up
    form(@submit.prevent="submit" v-disable-all="under18")
      .row(v-bind:class="v$.email.$error ? 'has_error' : ''")
        label(for="user_email") Email (Required)
        input(type="email" name="email" id="user_email" v-model="email" @change="v$.email.$touch" :readonly="emailChecked" aria-describedby="user_email_error")
        p.error(role="status" v-for="error of v$.email.$errors" :key="error.$uid" v-html="error.$message" id="user_email_error")
      .row(v-if="profileAlreadyExists")
        p Please check your email address to continue.
      div( v-if="emailChecked" )
        .row.two-cols
          div(v-bind:class="v$.first_name.$error ? 'has_error' : ''")
            label(for="user_first_name") First Name
            input(type="text" name="first_name" id="user_first_name" v-model="first_name" aria-describedby="user_first_name_error")
            p.error(role="status" v-for="error of v$.first_name.$errors" :key="error.$uid" v-html="error.$message" id="user_first_name_error")
          div(v-bind:class="v$.last_name.$error ? 'has_error' : ''")
            label(for="user_last_name") Last Name
            input(type="text" name="last_name" id="user_last_name" v-model="last_name" aria-describedby="user_last_name_error")
            p.error(role="status" v-for="error of v$.last_name.$errors" :key="error.$uid" v-html="error.$message" id="user_last_name_error")
      div( v-if="!profileAlreadyExists")
        .row.two-cols
          div(v-bind:class="v$.birth_month.$error ? 'has_error' : ''")
            label(for="user_birth_month") Birth Month (MM) (Required)
            input(type="number" maxlength="2" name="birth_month" id="user_birth_month" v-model="birth_month" aria-describedby="user_birth_month_error")
            p.error(role="status" v-for="error of v$.birth_month.$errors" :key="error.$uid" v-html="error.$message" id="user_birth_month_error")
          div(v-bind:class="v$.birth_year.$error ? 'has_error' : ''")
            label(for="user_birth_year") Birth Year (YYYY) (Required)
            input(type="number" name="birth_year" id="user_birth_year" v-model="birth_year" aria-describedby="user_birth_year_error")
            p.error(role="status" v-for="error of v$.birth_year.$errors" :key="error.$uid" v-html="error.$message" id="user_birth_year_error")
      div( v-if="emailChecked" )
        .row(v-bind:class="v$.postal_code.$error ? 'has_error' : ''")
          label(for="user_postal_code") Zip Code
          input(type="text" name="postal_code" id="user_postal_code" v-model="postal_code" aria-describedby="user_postal_code_error")
          p.error(role="status" v-for="error of v$.postal_code.$errors" :key="error.$uid" v-html="error.$message" id="user_postal_code_error")
        .row
          label(for="user_question1") What's your dietary preference?
          select(name="question1" id="user_question1" data-question="DietPreference" data-question-id="8270a1d0-46c1-4b88-a360-bffbafd337da")
            option(disabled selected) Select Answer
            <option value="Searching for KETO Snacks">Searching for KETO Snacks</option>
            <option value="Low Carb/Low Sugar Solutions">Low Carb/Low Sugar Solutions</option>
            <option value="Protein Seeker">Protein Seeker</option>
        .row(v-bind:class="v$.password.$error ? 'has_error' : ''")
          label(for="user_password") Password
          input(type="password" name="password" id="user_password" v-model="password" aria-describedby="user_password_error")
          p.error(role="status" v-for="error of v$.password.$errors" :key="error.$uid" v-html="error.$message" id="user_password_error")
        .row(v-bind:class="v$.password_confirmation.$error ? 'has_error' : ''")
          label(for="user_password_confirmation") Confirm Password
          input(type="password" name="password_confirmation" id="user_password_confirmation" v-model="password_confirmation" aria-describedby="user_password_confirmation_error")
          //p.error(role="status" v-for="error of v$.password_confirmation.$errors" :key="error.$uid" v-html="error.$message")
          p.error(role="status" v-if="v$.password_confirmation.$errors" id="user_password_confirmation_error")
        //.row(v-bind:class="v$.over18.$error ? 'has_error' : ''")
          label.checkbox-input
            input(type="checkbox" name="over18" id="user_over18" v-model="over18")
            span.checkbox-input__checkbox.checkbox--toggle-all.toggle-all-true
              <svg class="icon" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="M4.69 10.198 1.664 7.044 0 8.778l3.993 4.162.005-.005.729.76L16 1.945 14.304.177z" fill="currentColor"/></svg>
            .checkbox-input__label-text I am 18 years of age or older
          p.error(role="status" v-if="v$.over18.$error") Is required
      div( v-if="!profileAlreadyExists")
        .row(v-bind:class="v$.privacy_policy.$error ? 'has_error' : ''")
          label.checkbox-input
            input(type="checkbox" name="privacy_policy" id="user_privacy_policy" v-model="privacy_policy")
            span.checkbox-input__checkbox.checkbox--toggle-all.toggle-all-true
              <svg class="icon" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="M4.69 10.198 1.664 7.044 0 8.778l3.993 4.162.005-.005.729.76L16 1.945 14.304.177z" fill="currentColor"/></svg>
            .checkbox-input__label-text
              |I accept the General Mills!{' '}
              a( href="https://www.generalmills.com/privacy-security/us-english-privacy-policy" target="_blank" ) Privacy Policy
              |!{' '}and agree that my information may be used across the General Mills !{' '}
              a( href="https://www.generalmills.com/food-we-make/brands" target="_blank" ) family of brands
              |. I further agree to the!{' '}
              a( href="https://www.generalmills.com/privacy-security/legal-terms/us-english-terms-of-use" target="_blank" ) Terms and Conditions
              |!{' '}and the!{' '}
              a( href="https://www.generalmills.com/community-rules" target="_blank" ) Community Rules
              |.!{' '}I, also, understand that :ratio may send me emails relating to my participation in this community. (required)
          p.error(role="status" v-for="error of v$.privacy_policy.$errors" :key="error.$uid" v-html="error.$message")
      div( v-if="emailChecked" )
        .row
          label.checkbox-input
            input(type="checkbox" name="subscribe" id="user_subscribe" v-model="subscribe")
            span.checkbox-input__checkbox.checkbox--toggle-all.toggle-all-true
              <svg class="icon" viewBox="0 0 16 14" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><path d="M4.69 10.198 1.664 7.044 0 8.778l3.993 4.162.005-.005.729.76L16 1.945 14.304.177z" fill="currentColor"/></svg>
            .checkbox-input__label-text
              |I’d like to receive product updates, offers and cart follow-ups from :ratio via email (optional)
      div.btn(v-if="under18") Sorry, you are not eligible to register at this time.
      .row(v-if="!under18 && !profileAlreadyExists")
        input.btn--primary(type="submit" :value="emailChecked ? 'Create Account' : 'Check Email'")
      .row.link
        | Forgot Password? <a href="#" @click.prevent="$parent.setPage('forgot')">Click here</a>
      .row.link
        | Already have an account? <a href="#" @click.prevent="$parent.setPage('signin')">Login here</a>
</template>

<script>
  const Rule2Property = {
    'first name': 'first_name',
    'last name': 'last_name',
    'zip.code.rule': 'postal_code',
    'unique.email.rule': 'email',
    'password.strength.rule': 'password'
  };

  import { email, helpers, numeric, minValue, maxValue, sameAs } from '@vuelidate/validators';
  import { mandatory, minSize, maxSize } from '../../helpers/validators.js';
  import { useVuelidate } from '@vuelidate/core';

  export default {
    name: 'Signup',

    components: {
    },

    props: {
    },

    setup() {
      return {
        v$: useVuelidate(null, null, {
          $lazy: true,
          $autoDirty: true
        })
      }
    },

    mounted() {
      this.$parent.createRecaptcha();
      this.$el.querySelector('#user_email').focus();

      if (localStorage.getItem('under18') == 'yes')
        this.under18 = true;
    },

    data() {
      return {
        emailChecked: false,
        profileAlreadyExists: false,

        under18: false,
        first_name: '',
        last_name: '',
        email: '',
        birth_month: '',
        birth_year: '',
        postal_code: '',
        password: '',
        password_confirmation: '',
        // over18: false,
        privacy_policy: false,
        subscribe: false,
        vuelidateExternalResults: {
          first_name: [],
          last_name: [],
          birth_month: [],
          birth_year: [],
          postal_code: [],
          email: [],
          password: []
        }
      }
    },

    validations () {
      return {
        first_name: { required: mandatory('First name') },
        last_name: { required: mandatory('Last name') },
        email: { required: mandatory('Email'), email },
        birth_month: { required: mandatory('Birth month'), numeric, min: minValue(1), max: maxValue(12) },
        birth_year: { required: mandatory('Birth year'), numeric, min: minValue(1900), max: maxValue(2050) },
        postal_code: { minLength: minSize('Zip code', 5), maxLength: maxSize('zip code', 5) },
        password: { minLength: minSize('Password', 8), maxLength: maxSize('Password', 128) },
        password_confirmation: { sameAs: helpers.withMessage(
          'Password are not matching',
          sameAs(this.password)
        ) },
        // over18: { shouldBeChecked: sameAs(true) },
        privacy_policy: { shouldBeChecked: helpers.withMessage(
          'Please indicate that you have read and agree to the Terms and Conditions, Privacy Policy and Community Rules',
          sameAs(true)
        ) }
      }
    },

    methods: {
      async sendForgotPasswordEmail() {
        // send consent
        fetch(
          this.$parent.url + 'register', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              email: this.email,
              consent: true
            })
          }
        );

        this.$parent.getRecaptchaToken((token) => {
          fetch(
            this.$parent.url + 'send-password-reset', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                email: this.email,
                recaptcha_token: token
              })
            }
          ).then(response => response.json()).then(data => {
            console.log(data)
            /*if (data.Result !== 'Success') {
              Object.assign(this.vuelidateExternalResults, { email: 'Not Found!' });
              return;
            }*/
            this.profileAlreadyExists = true;
          }).catch(() => {
          });
        });
      },

      async submit() {
        this.profileAlreadyExists = false;

        for (const key in this.vuelidateExternalResults)
          this.vuelidateExternalResults[key] = [];

        const formValid = await this.v$.$validate();
        const birth_date = `${this.birth_year}-${this.birth_month}-01`;

        // Age gate
        if (!this.v$.birth_year.$error && !this.v$.birth_month.$error) {
          const age = (new Date() - new Date(birth_date)) / (1000 * 60 * 60 * 24 * 365);
          if (age < 18) {
            localStorage.setItem('under18', 'yes');
            this.under18 = true;
            return;
          }
        }

        if (!this.emailChecked && !this.v$.email.$error && !this.v$.birth_year.$error && !this.v$.birth_month.$error && this.privacy_policy) {
          // Check profile existence
          fetch(
            this.$parent.url + 'profile-check', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ email: this.email })
            }
          ).then(response => response.json()).then(data => {
            if (data.Status === 'User') {
              // Send password reset email
              this.sendForgotPasswordEmail();
            } else
              this.emailChecked = true;
            this.v$.$reset();
          }).catch(() => {
          });
          return;
        }

        if (!formValid) {
          this.$el.querySelector('.has_error input').focus();
          return;
        }

        const questions = [];
        document.querySelectorAll('select[data-question]').forEach((v) => {
          if (/^[0-9A-F\-]+$/.test(v.value) && v.value.length == 36)
            questions.push({ "QuestionCode": v.getAttribute('data-question'), "Answer": { "AnswerId": v.value } });
          else
            questions.push({ "QuestionCode": v.getAttribute('data-question'), "Answer": { "AnswerText": v.value } });
        });

        const data = {
          email: this.email,
          first_name: this.first_name,
          last_name: this.last_name,
          // birth_date: birth_date,
          birth_month: this.birth_month,
          birth_year: this.birth_year,
          postal_code: this.postal_code,
          password: this.password,
          subscribe: this.subscribe,
          consent: true,
          questions: questions
        };

        // Sign Up
        // 'email', 'birth_date', 'password', 'first_name', 'last_name', 'postal_code', 'source_code', 'questions'
        this.$parent.getRecaptchaToken((token) => {
          data.recaptcha_token = token;
          fetch(
            this.$parent.url + 'register', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            }
          ).then(response => response.json()).then(data => {
            if (data.Errors) {
              const errors = {};
              for (const v of data.Errors) {
                const p = Rule2Property[v.RuleId] || Rule2Property[v.FieldName];
                if (!p)
                  continue;
                if (errors[p])
                  errors[p].push(v.Message);
                else
                  errors[p] = [ v.Message ];
              }
              Object.assign(this.vuelidateExternalResults, errors);
              return;
            }

            // signed up successfully
            this.$parent.setSession(data);

            window.location = data.shopify_url;
            // this.$parent.setPage('profile');
          }).catch(() => {
          });
        });
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
